<div class="speech-recorder">
  @if (!isSupported) {
    <div class="speech-recorder-message">
      <mat-icon>mic_off</mat-icon>
      <span>{{ 'components.surveys.speech-to-text.unsupported-browser' | translate }}</span>
    </div>
  }

  @if (errorMessage && !uploadFailed) {
    <div class="speech-recorder-message warning">
      <mat-icon>info</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  }

  <div class="speech-recorder-actions">
    @if (!isRecording && !isUploading && !uploadFailed) {
      <button
        mat-raised-button
        color="primary"
        type="button"
        class="speech-recorder-button"
        [disabled]="disabled || !isSupported"
        (click)="startRecording()">
        <mat-icon>mic</mat-icon>
        {{ 'components.surveys.speech-to-text.record-answer' | translate }}
      </button>
    }

    @if (isRecording) {
      <button
        mat-raised-button
        color="warn"
        type="button"
        class="speech-recorder-button"
        (click)="stopRecording()">
        <mat-icon>stop</mat-icon>
        {{ 'components.surveys.speech-to-text.stop-and-transcribe' | translate }}
      </button>

      <button
        mat-button
        type="button"
        class="speech-recorder-cancel"
        (click)="cancelRecording()">
        {{ 'generic.cancel' | translate }}
      </button>

      <span class="speech-recorder-timer">
        {{ formattedElapsed }} / {{ formattedMaxDuration }}
      </span>
      <div class="speech-recorder-vu-meter" aria-label="Microphone level meter">
        @for (segment of micMeterSegments; track segment) {
          <span
            class="vu-segment"
            [class.active]="segment < activeMicSegments"
            [class]="getMicSegmentClass(segment)">
          </span>
        }
      </div>
    }

    @if (isUploading) {
      <div class="speech-recorder-loading">
        <mat-spinner diameter="20"></mat-spinner>
        <span>{{ processingMessageKey | translate }}</span>
      </div>
    }

    @if (uploadFailed && !isUploading) {
      <div class="speech-recorder-retry-row">
        @if (errorMessage) {
          <div class="speech-recorder-message warning inline">
            <mat-icon>info</mat-icon>
            <span>{{ errorMessage }}</span>
          </div>
        }
        <button
          mat-stroked-button
          type="button"
          class="speech-recorder-button"
          (click)="retryUpload()">
          <mat-icon>refresh</mat-icon>
          {{ 'components.surveys.speech-to-text.retry-upload' | translate }}
        </button>
      </div>
    }
  </div>
</div>
